export default __webpack_public_path__ + "static/media/simpleCamera.f6bab961.svg";